import { Options } from 'react-select';
import styled from 'styled-components';
import { useCounterpartiesOptions } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/counterparties/context';
import {
  useRfqFiltersFormActions,
  useRfqFiltersFormView,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/form-context';
import {
  FormView,
  Field,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/form-view';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import Select from '@paradigm/design-system/src/components/Select';
import { OptionTypeBase } from '@paradigm/design-system/src/components/Select/types';
import { CounterpartySelectorPopover } from '#/components/UnifiedRfqs/rfq-filters/CounterpartySelectorPopover';

export default function RfqFilterForm() {
  const {
    venues,
    assets,
    instruments,
    auctionTypes,
    products,
    strategies,
    counterparties,
  } = useRfqFiltersFormView();
  const { selectValues } = useRfqFiltersFormActions();
  useCounterpartiesOptions();

  function selectFieldValues<T extends Field>(
    field: T,
    values: Options<OptionTypeBase>,
  ) {
    selectValues(field, values as FormView[T]['selectedOptions']);
  }

  return (
    <div>
      <MultiSelectContainer>
        <Title>Venue</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('venues', values)}
          options={venues.options}
          value={venues.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Asset</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('assets', values)}
          options={assets.options}
          value={assets.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Product</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('products', values)}
          options={products.options}
          value={products.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Instrument</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('instruments', values)}
          options={instruments.options}
          value={instruments.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Strategies</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('strategies', values)}
          options={strategies.options}
          value={strategies.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Auction Type</Title>
        <Select
          isMulti
          placeholder="Search..."
          onChange={(values) => selectFieldValues('auctionTypes', values)}
          options={auctionTypes.options}
          value={auctionTypes.selectedOptions}
        />
      </MultiSelectContainer>
      <MultiSelectContainer>
        <Title>Counterparty (Taker)</Title>
        <CounterpartySelectorPopover
          value={counterparties.selectedOptions}
          onChange={(values) => selectFieldValues('counterparties', values)}
        />
      </MultiSelectContainer>
    </div>
  );
}

const Title = styled.div`
  margin-bottom: 0.25rem;
  margin-top: 12px;
  font-size: 0.8125rem;
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 500;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
`;

const MultiSelectContainer = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-bottom: 1.5rem;
  }
`;
